var _defs, _g, _path, _path2, _path3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        fill-rule: evenodd;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2, .cls-8 {\n        fill: #ffcc3e;\n      }\n\n      .cls-9 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2093.22,
    y1: 1719.2,
    x2: -2091.61,
    y2: 1719.2,
    gradientTransform: "translate(540108.89 443823.79) scale(257.89 -257.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fef1cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6dd95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2090.64,
    y1: 1719.26,
    x2: -2089.04,
    y2: 1719.26,
    gradientTransform: "translate(420369.77 345877.58) scale(200.91 -200.91)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc3700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2082.87,
    y1: 1702.5,
    x2: -2081.26,
    y2: 1702.5,
    gradientTransform: "translate(240252.79 1563.93) rotate(-39.08) scale(89.21 -89.21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa501"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -2125.07,
    y1: 1696.42,
    x2: -2123.47,
    y2: 1696.42,
    gradientTransform: "translate(-19148.96 -202734.25) rotate(-134.17) scale(75.2 -75.2)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 392.85,
    y1: 658.37,
    x2: 458.09,
    y2: 658.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 472.85,
    y1: 655.36,
    x2: 531.8,
    y2: 655.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 546.07,
    y1: 658.84,
    x2: 612.29,
    y2: 658.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M767.99,658.84h-75.5l-75.5,42.59v42.59h151l-22.73-42.59,22.73-42.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.15,658.84h75.5l75.5,42.59v42.59H237.15l22.73-42.59s-22.73-42.59-22.73-42.59Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 502.57,
    cy: 463.86,
    r: 207.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 502.57,
    cy: 463.86,
    r: 161.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 312.65,
    y: 616.25,
    width: 379.84,
    height: 85.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M388.15,744.03l-75.5-42.59h75.5v42.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M616.99,744.03l75.5-42.59h-75.5v42.59Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M422.48,628.93c.6-1.08,1.75-1.75,2.99-1.75s2.38,.67,2.99,1.75l8.91,15.99,17.96,3.54c1.22,.24,2.21,1.12,2.59,2.3,.38,1.18,.1,2.47-.75,3.38l-12.45,13.42,2.19,18.17c.15,1.23-.38,2.45-1.39,3.18-1,.73-2.32,.86-3.45,.34l-16.61-7.7-16.61,7.7c-1.13,.52-2.44,.39-3.45-.34-1-.73-1.53-1.94-1.39-3.18l2.19-18.17-12.45-13.42c-.84-.91-1.13-2.2-.75-3.38,.38-1.18,1.38-2.06,2.59-2.3l17.96-3.54,8.91-15.99h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M499.63,628.76c.55-.98,1.58-1.59,2.7-1.59s2.15,.61,2.7,1.59l8.05,14.45,16.23,3.19c1.1,.22,2,1.01,2.34,2.08,.35,1.07,.09,2.24-.67,3.06l-11.25,12.12,1.98,16.42c.13,1.11-.35,2.21-1.25,2.87-.91,.66-2.1,.77-3.12,.3l-15.01-6.95-15.01,6.95c-1.02,.47-2.21,.36-3.12-.3-.91-.66-1.39-1.76-1.25-2.87l1.98-16.42-11.25-12.12c-.76-.82-1.02-1.99-.67-3.06,.35-1.07,1.24-1.86,2.34-2.08l16.23-3.19,8.05-14.45h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M576.15,628.96c.61-1.1,1.77-1.78,3.03-1.78s2.42,.68,3.03,1.78l9.05,16.23,18.23,3.59c1.24,.24,2.24,1.14,2.63,2.33,.39,1.2,.1,2.51-.76,3.43l-12.64,13.62,2.22,18.45c.15,1.25-.39,2.48-1.41,3.22-1.02,.74-2.36,.87-3.5,.34l-16.86-7.81-16.86,7.81c-1.14,.53-2.48,.4-3.5-.34-1.02-.74-1.56-1.97-1.41-3.22l2.22-18.45-12.64-13.62c-.86-.92-1.15-2.24-.76-3.43,.39-1.2,1.4-2.09,2.63-2.33l18.23-3.59,9.05-16.23h0Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M522.22,531.14c-11.91,0-23.83-.4-35.71,.14-8.31,.37-14.38-3.94-20.87-7.75-2.47-1.45-2.37-3.93-2.37-6.32,0-23.81,.02-47.63-.03-71.44,0-3.03,.82-5.32,3.41-7.2,23.48-17.06,33-40.85,33.05-69.14,0-.65,0-1.3,0-1.95-.07-11.48,4.27-14.19,14.98-9.06,10.88,5.21,13.33,15.38,14.15,25.99,.79,10.15,.35,20.35-1.92,30.35-1.22,5.38,.01,7.59,6.12,6.92,15.08-1.67,30.21-2.41,45.21,.88,2.32,.51,4.66,1.04,6.9,1.82,12.14,4.26,15.97,12.94,10.28,24.51-2.09,4.25-2.73,7.5-.23,11.94,3.94,7,2.67,12.26-3.79,17.02-3.65,2.68-4.03,5.38-3.22,9.44,1.38,6.94,.58,13.48-6.13,17.76-3.04,1.94-2.82,5.22-3.36,8.09-2.64,14-7.43,18.07-21.38,18.02-11.69-.04-23.38,0-35.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M402.04,482.76c0-12.32-.06-24.65,.03-36.97,.06-7.98,2.13-10.11,9.93-10.16,12.32-.09,24.65-.08,36.97,0,7.57,.05,10.15,2.09,10.23,9.36,.29,24.85,.4,49.71,.25,74.57-.05,8.52-3.05,11.11-11.64,11.22-11.67,.14-23.35,.17-35.02,0-8.31-.12-10.7-2.69-10.74-11.04-.06-12.32-.02-24.65,0-36.97Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.e04d67d579a71d9dec9985544a9a7a9a.svg";
export { ForwardRef as ReactComponent };